import React, {Component} from 'react'
import { connect } from "react-redux"

function mapStateToProps(state) {
  return {
   	page: state.page.data,
   	loading: state.page.loading
  };
}

class Site extends Component {

	constructor(props) {
		super(props)
	}

	
	render()

	{
		
		let {page, loading} = this.props
		let modifier;

		if(page == undefined ) {

			modifier = "standard"

		} else {

			modifier = (!loading) ? page.slug.replace('-', '') : 'standard';

		}

		
		
		
		return (
			<div className={"Site Site--" + modifier}>
				{this.props.children}
			</div>
		);
	}

}

export default connect(mapStateToProps)(Site)


// WEBPACK FOOTER //
// ./src/js/components/Site/Site.js